"use strict"

import React from "react"

import { Button, Form } from "react-bootstrap"
import { isLTPM } from "../../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  single_tag_selection: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.single.tag.selection" }) : "Single Tag Selection",
  multi_tag_selection: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.multi.tag.selection" }) : "Multi Tag Selection",
  update_plot_text: (intl) => (isLTPM ? intl.formatMessage({ id: "general.update" }) : "Update"),
  search_text: (intl) => (isLTPM ? intl.formatMessage({ id: "general.search" }) : "Search"),
}

export default function SingleMultiTagSelectionRadio({
  intl,
  currentSelection,
  updateTagSelect,
  disabled,
  onMultiTagSubmit,
}) {
  return (
    <div key={"default-radio"} className={"mb-0"}>
      <Form.Check
        label={registration.single_tag_selection(intl)}
        name={"tag_select"}
        style={{ fontSize: "90%" }}
        type={"radio"}
        checked={currentSelection === "single"}
        onChange={() => updateTagSelect("single")}
        id={"tag-sel-radio-1"}
      />
      <div style={{ display: "flex" }}>
        <Form.Check
          label={registration.multi_tag_selection(intl)}
          name={"tag_select"}
          style={{ fontSize: "90%" }}
          type={"radio"}
          checked={currentSelection === "multiple"}
          onChange={() => updateTagSelect("multiple")}
          id={"tag-sel-radio-2"}
        />
        {currentSelection === "multiple" && (
          <Button
            className={"bordered-button"}
            variant={"primary"}
            size={"sm"}
            style={{
              marginLeft: "auto",
              padding: "2px",
              paddingLeft: "3px",
              paddingRight: "3px",
            }}
            disabled={disabled}
            onClick={onMultiTagSubmit}
          >
            {registration.update_plot_text(intl)}
          </Button>
        )}
      </div>
      <hr style={{ margin: "2px" }} />
    </div>
  )
}
